import {
	FunctionalCapacity, FunctionalCapacityChildrenDiagram,
	FunctionalCapacityGroupDiagram
} from "../../../../../services/back/functional-capacities.service";
import {drawCapacitiesApp, preloadAppImages} from "./draw-capacities-app";
import {drawOptionButton} from "./draw-capacities";

const VIOLET_COLOR = 'rgba(168, 144, 243, 1)';
const VIOLET_COLOR_TRANSPARENT = 'rgba(168, 144, 243, 0.03)';
const ROSE_COLOR = 'rgba(237, 235, 249, 1)';
const WHITE_COLOR = 'rgba(255, 255, 255, 1)';

export async function drawCapacitiesChild(
	ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
	data: FunctionalCapacityChildrenDiagram,
	x: number,
	y: number,
	gridSize: number,
	angle: number,
	registerButton: (id: string, name: string, type: string, x: number, y: number, width: number, height: number) => void,
	isButtonHovered: (id: string) => boolean,
	scale: number
): Promise<void> {

	let title = data.name;
	const zoneWidth = 9 * gridSize;
	const nbApp: number = data.applications.length;
	let zoneHeight = gridSize;
	if (nbApp > 4) {
		zoneHeight += (Math.ceil(nbApp / 4) * (2 * gridSize)) + gridSize;
	} else {
		zoneHeight += 3 * gridSize;
	}

	//Draw Element
	drawZone(ctx, x, y, zoneWidth, zoneHeight, angle);
	if (data.applications.length === 0) {
		registerButton(data.id, "capacity", 'child-capacity', x, y + gridSize, zoneWidth, zoneHeight - gridSize);
	}

	//Draw Title
	drawTitle(ctx, x, y, zoneWidth, gridSize, angle, title, registerButton);

	const buttonX = x + zoneWidth - gridSize;
	const buttonY = y;
	const buttonWidth = gridSize;
	const buttonHeight = gridSize;
	const buttonId = data.id;
	const isHovered = isButtonHovered(buttonId)

	drawOptionButton(ctx, buttonX, buttonY, buttonWidth, isHovered, 'rose');
	registerButton(buttonId, "option-button", 'capacity-option', buttonX, buttonY, buttonWidth, buttonHeight);

	await preloadAppImages(data.applications);
	await drawCapacitiesApp(ctx, data.applications, data.id, x, y, gridSize, angle, registerButton, isButtonHovered, scale);
}

function drawZone(
	ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
	x: number,
	y: number,
	width: number,
	height: number,
	angle: number,
): void {

	ctx.beginPath()
	ctx.strokeStyle = VIOLET_COLOR;
	ctx.lineWidth = 1;
	ctx.fillStyle = VIOLET_COLOR_TRANSPARENT;
	ctx.roundRect(x, y, width, height, [angle])
	ctx.stroke()
	ctx.fill()
}

function drawTitle(
	ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
	x: number,
	y: number,
	width: number,
	gridSize: number,
	angle: number,
	title: string,
	registerButton: (id: string, name:string, type: string, x: number, y: number, width: number, height: number) => void,
): void {

	// Dessin du rectangle
	ctx.beginPath()
	ctx.strokeStyle = VIOLET_COLOR;
	ctx.lineWidth = 1;
	ctx.fillStyle = ROSE_COLOR;
	ctx.roundRect(x, y, width, gridSize, [angle])
	ctx.fill()
	ctx.stroke()

	// Dessin du text
	let text = title;
	const maxWidth = gridSize * 8 - (gridSize/3);

	ctx.font = '500 13px proxima-nova';
	const textMetrics = ctx.measureText(text);
	const textWidth = textMetrics.width;

	if (textWidth > maxWidth) {
		// Trouver la longueur optimale
		let truncatedText = text;
		while (ctx.measureText(truncatedText + '...').width > maxWidth && truncatedText.length > 0) {
			truncatedText = truncatedText.slice(0, -1);
		}
		text = truncatedText + '...';
		registerButton("01", title, 'tool-tip-name', x, y + (gridSize/4), gridSize * 8, gridSize/2);
	}

	ctx.fillStyle = VIOLET_COLOR;
	ctx.textAlign = 'left';
	ctx.textBaseline = 'middle';
	ctx.letterSpacing = "-0.1px";
	ctx.fillText(text, x + gridSize/3, y + gridSize / 2);
}

export function drawPlusButton(
	ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
	x: number,
	y: number,
	isHovered: boolean,
	gridSize: number,
):void {

	ctx.save()

	if(!isHovered) {
		ctx.clearRect(x + 1, y + 1, gridSize - 1, gridSize - 1);
		ctx.beginPath()
		ctx.fillStyle = VIOLET_COLOR_TRANSPARENT
		ctx.rect(x + 1, y + 1, gridSize - 1, gridSize - 1)
		ctx.fill()
		ctx.rect(x + 1, y + 1, gridSize - 1, gridSize - 1)
		ctx.fill()

	} else {
		ctx.beginPath();
		ctx.strokeStyle = VIOLET_COLOR;
		ctx.lineWidth = 1;
		ctx.roundRect(x + 2, y + 2, gridSize - 3, gridSize - 3, [8]);
		ctx.stroke();
		ctx.beginPath();
		ctx.strokeStyle = VIOLET_COLOR;
		ctx.fillStyle = ROSE_COLOR;
		ctx.lineWidth = 1.5;
		ctx.lineCap = 'round';
		ctx.moveTo(x + gridSize / 2 + .5, y + gridSize / 3 + .5);
		ctx.lineTo(x + gridSize / 2 + .5, y + (gridSize / 3) * 2 + .5);
		ctx.moveTo(x + gridSize / 3 + .5, y + gridSize / 2 + .5);
		ctx.lineTo(x + (gridSize / 3) * 2 + .5, y + gridSize / 2 + .5);
		ctx.fill();
		ctx.stroke();
	}

	ctx.restore();
}
